export default "__VITE_PUBLIC_ASSET__59ec8b01__"